// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content {
    padding: 32px;
}


.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar {
    padding: 14px 20px;
    align-items: center;
    justify-content: flex-end;
}

.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar .Polaris-Button {
    width: 50px;
    max-height: 28px;
    min-height: unset;
    padding: 10px 6px;
    border-radius: 8px;
    box-shadow: 0px 1px 0px 0px #E3E3E3 inset, 1px 0px 0px 0px #E3E3E3 inset, -1px 0px 0px 0px #E3E3E3 inset, 0px -1px 0px 0px #B5B5B5 inset;
}

.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar .Polaris-Button .Polaris-Button__Content {
    font-size: 12px;
    font-weight: 500;
}

.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar .Polaris-FullscreenBar__BackAction {
    display: none;
}

.BC-Onboarding-Plan-Modal h1 {
    font-weight: 700;
    font-size: 28px;
    text-align: center;
    margin-bottom: 8px;
    line-height: 36px;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .subtitle {
    text-align: center;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .BC-Page__SubscriptionV3 {
    max-width: 1172px;
    margin: auto;
    margin-top: 24px;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .BC-Page__SubscriptionV3.V4 .permonth {
    font-size: 12px !important;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .BC-Page__SubscriptionV3.V4 .price,
.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .BC-Page__SubscriptionV3.V4 .price>.price-number {
    font-size: 36px !important;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .compare-action {
    background-color: #F6F6F7;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .compare-action .btn-compare .Polaris-Button {
    background-color: transparent;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .compare-action .btn-compare .Polaris-Button__Text {
    display: flex;
    gap: 4px;
    align-items: center;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .compare-action .btn-compare .Polaris-Button .Polaris-Icon {
    margin: 0;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .compare-action .btn-compare.btn-compare--expand .Polaris-Icon {
    transform: rotate(180deg);
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .package-comparison-head {
    margin-bottom: 48px;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .package-comparison-table {
    width: 100%;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .package-comparison-head h1 {
    font-weight: 700;
    font-size: 28px;
    line-height: 36px;
    margin-bottom: 8px;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .package-comparison-head p {
    text-align: center;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .column-package--success .Polaris-Button {
    background: #008060;
    border-color: #008060;
    color: #ffffff;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .collapse-table {
    overflow: auto;
    max-height: 500px;
}

.BC-Onboarding-Plan-Modal .btn-to-top {
    position: fixed;
    bottom: 80px;
    right: 28px;
    z-index: 99;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #007F5F;
    cursor: pointer;
    transition: 0.3s all cubic-bezier(0.075, 0.82, 0.165, 1);
}

.BC-Onboarding-Plan-Modal .btn-to-top .Polaris-Icon {
    width: 18px;
    height: 18px;
}

.BC-Onboarding-Plan-Modal .btn-to-top .Polaris-Icon .Polaris-Icon__Svg {
    fill: #007F5F;
}

.BC-Onboarding-Plan-Modal .btn-to-top:hover {
   background-color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/styles/onboarding-plan.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;;AAGA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,wIAAwI;AAC5I;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,eAAe;IACf,wDAAwD;AAC5D;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;GACG,sBAAsB;AACzB","sourcesContent":[".BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content {\n    padding: 32px;\n}\n\n\n.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar {\n    padding: 14px 20px;\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar .Polaris-Button {\n    width: 50px;\n    max-height: 28px;\n    min-height: unset;\n    padding: 10px 6px;\n    border-radius: 8px;\n    box-shadow: 0px 1px 0px 0px #E3E3E3 inset, 1px 0px 0px 0px #E3E3E3 inset, -1px 0px 0px 0px #E3E3E3 inset, 0px -1px 0px 0px #B5B5B5 inset;\n}\n\n.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar .Polaris-Button .Polaris-Button__Content {\n    font-size: 12px;\n    font-weight: 500;\n}\n\n.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar .Polaris-FullscreenBar__BackAction {\n    display: none;\n}\n\n.BC-Onboarding-Plan-Modal h1 {\n    font-weight: 700;\n    font-size: 28px;\n    text-align: center;\n    margin-bottom: 8px;\n    line-height: 36px;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .subtitle {\n    text-align: center;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .BC-Page__SubscriptionV3 {\n    max-width: 1172px;\n    margin: auto;\n    margin-top: 24px;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .BC-Page__SubscriptionV3.V4 .permonth {\n    font-size: 12px !important;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .BC-Page__SubscriptionV3.V4 .price,\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .BC-Page__SubscriptionV3.V4 .price>.price-number {\n    font-size: 36px !important;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .compare-action {\n    background-color: #F6F6F7;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .compare-action .btn-compare .Polaris-Button {\n    background-color: transparent;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .compare-action .btn-compare .Polaris-Button__Text {\n    display: flex;\n    gap: 4px;\n    align-items: center;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .compare-action .btn-compare .Polaris-Button .Polaris-Icon {\n    margin: 0;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .compare-action .btn-compare.btn-compare--expand .Polaris-Icon {\n    transform: rotate(180deg);\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .package-comparison-head {\n    margin-bottom: 48px;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .package-comparison-table {\n    width: 100%;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .package-comparison-head h1 {\n    font-weight: 700;\n    font-size: 28px;\n    line-height: 36px;\n    margin-bottom: 8px;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .package-comparison-head p {\n    text-align: center;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .column-package--success .Polaris-Button {\n    background: #008060;\n    border-color: #008060;\n    color: #ffffff;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .collapse-table {\n    overflow: auto;\n    max-height: 500px;\n}\n\n.BC-Onboarding-Plan-Modal .btn-to-top {\n    position: fixed;\n    bottom: 80px;\n    right: 28px;\n    z-index: 99;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid #007F5F;\n    cursor: pointer;\n    transition: 0.3s all cubic-bezier(0.075, 0.82, 0.165, 1);\n}\n\n.BC-Onboarding-Plan-Modal .btn-to-top .Polaris-Icon {\n    width: 18px;\n    height: 18px;\n}\n\n.BC-Onboarding-Plan-Modal .btn-to-top .Polaris-Icon .Polaris-Icon__Svg {\n    fill: #007F5F;\n}\n\n.BC-Onboarding-Plan-Modal .btn-to-top:hover {\n   background-color: #fff;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
